"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
var messages_es_1 = require("./messages_es");
var messages_cat_1 = require("./messages_cat");
window.adperfTracker = window.adperfTracker || {};
exports.config = {
    apiKey: APIKEY,
    backendHost: BACKENDHOST,
    backendPoint: BACKENDHOST + "/Wizards/submit&queue=true",
    context: {
        defaultCountryCode: "ES",
        channelCode: "WEB_FV",
        templateCode: "CALCULOS_ESTIMATED_SAVINGS",
        wizardCode: "GALLEGO_SITES",
        urlOk: "http://gallegotelecomunicaciones.es/",
        domainId: DOMAINID,
        moduleRef: "6420015015",
        flatStructureRef: "WURTH - Kit montaje 3 placas coplanares",
        inclinationStructureRef: "WURTH - Kit montaje 3 placas inclinadas",
        defaultVoltage: "3X400",
        defaultPhases: "3",
        defaultProfileRef: "ESTIMATE00INDUSTRIA",
        defaultAnnualPowerPriceIncrease: 0.2,
        defaultAnnualPerformanceLoss: 0.4,
        defaultAnnualPowerConsumptionIncrease: 0,
        financingType: "none",
        defaultTariff: "2.0TD",
        individualTariff: "2.0TD",
        organizationTariff: "3.0TD",
        defaultContractedPower: 4.7,
        individualContractedPower: 4.7,
        organizationContractedPower: 30,
        individualMaxConsume: 400,
        organizationMaxConsume: 5000,
        individualDefaultConsume: 75,
        organizationDefaultConsume: 800,
        defaultModulesTilt: 20,
        defaultModulesAzimuth: 0,
        regionAutocomplete: "es",
        solutionCode: "OFERTAS_FV",
        pipelineCode: "VENTAS_FV",
    },
    formMessages: {
        es: messages_es_1.messages_es,
        cat: messages_cat_1.messages_cat,
    },
    provinces: [
        "Araba/Álava",
        "Albacete",
        "Alicante/Alacant",
        "Almería",
        "Ávila",
        "Badajoz",
        "Balears, Illes",
        "Barcelona",
        "Burgos",
        "Cáceres",
        "Cádiz",
        "Castellón/Castelló",
        "Ciudad Real",
        "Córdoba",
        "Coruña, La",
        "Cuenca",
        "Girona",
        "Granada",
        "Guadalajara",
        "Gipuzkoa",
        "Huelva",
        "Huesca",
        "Jaén",
        "León",
        "Lleida",
        "Rioja, La",
        "Lugo",
        "Madrid",
        "Málaga",
        "Murcia",
        "Navarra",
        "Ourense",
        "Asturias",
        "Palencia",
        "Palmas, Las",
        "Pontevedra",
        "Salamanca",
        "Santa Cruz de Tenerife",
        "Cantabria",
        "Segovia",
        "Sevilla",
        "Soria",
        "Tarragona",
        "Teruel",
        "Toledo",
        "Valencia/València",
        "Valladolid",
        "Bizkaia",
        "Zamora",
        "Zaragoza",
        "Ceuta",
        "Melilla",
    ],
    redirect: true,
    showCalculations: false,
    showInclination: false,
    showLanguageSelector: false,
    showOrientation: false,
    showRecommender: false,
    showModules: false,
};
